import type { CustomerConfig } from "../../types";

export const jlrConfig: CustomerConfig = {
	id: "jlr",
	name: "Jaguar Land Rover",
	shortName: "JLR",
	accessTokens: ["00d37d2304ef4a6d8f6b0a4afa410727"],
	accessExpiry: new Date("2026-08-01T23:59:59Z"),
	onsiteDates: "June 8, 2026",
	theme: {
		accentColor: "#16a34a",
		accentColorLight: "#4ade80",
		secondaryAccent: "#BFBFBF",
		pathColorFrom: "#16a34a",
		pathColorTo: "#BFBFBF",
		slideAccentBar: "#16a34a",
	},
	logos: {
		customer: "/assets/logos/jlr.svg",
		null: "/null/logo.white.svg",
	},
	demoUrl: "https://app.dev.null.autos",
	demoLabel: "Launch Null Autos Platform",
	confidentialityNotice:
    "CONFIDENTIAL — Any disclosure, use, reproduction, or distribution of this information without the express written consent of Null Autos is strictly prohibited.",
};
